import { Column, Heading, Stack, breakpoints, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import type { ReactNode } from 'react';

const textStyles = css`
  font-size: 0.875rem;
`;

const columnWidth = { [breakpoints._0]: '4/4', [breakpoints._768]: '2/6' } as const;

const inlineStyles = css`
  font-size: 0.875rem;

  @media (min-width: ${breakpoints._768}) {
    flex-direction: column;
    font-size: 1rem;
    gap: 4px;
    text-align: center;
  }

  @media (min-width: ${breakpoints._1024}) {
    flex-flow: row nowrap;
    gap: 16px;
    text-align: start;
  }
`;
interface UniqueSellingPointProps {
  icon: ReactNode;
  label?: string;
  title?: string;
}

const UniqueSellingPoint = ({ icon, label, title }: UniqueSellingPointProps) => (
  <Column as="li" width={columnWidth}>
    <Inline align="center" alignY="center" className={inlineStyles} spacing={8}>
      <Inline aria-hidden> {icon}</Inline>
      <Stack spacing={4}>
        {title && (
          <Heading as="span" level={4}>
            {title}
          </Heading>
        )}
        {label && <p className={textStyles}>{label}</p>}
      </Stack>
    </Inline>
  </Column>
);

export default UniqueSellingPoint;
